import { Divider, DividerProps } from 'primereact/divider';
import React, { PropsWithChildren } from 'react';
import { PDividerStyle as S } from './PDivider.style';

/**
 * @deprecated Use Divider instead
 */
export const PDivider = React.forwardRef<Divider, PropsWithChildren<DividerProps>>((props, ref) => {
  return <S.Divider layout="horizontal" type="solid" {...props} ref={ref} />;
});
